import { useTranslation } from "react-i18next";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import { complexDigitToman, convertToJalaliWithTime } from "../../../../tools/tools";
import PendingDocsPage from "../../../auxiliary/pending/PendingDocsPage";
import "../../change/cs.scss";

const CSListPendingDocument = () => {
	const [t] = useTranslation("global");
	const { querySWPurchaseDealerByState } = useDealer();
	return (
		<PendingDocsPage
			title={t("simcardreplacement.pending.list.title")}
			prefix="cs"
			query={querySWPurchaseDealerByState}
			stateFilter={{ simSwapState: [8, 9] }}
			commissionTitle="پورسانت"
			uploadPath={_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Pending.Index + _adr.SimCardReplacement.Pending.upload}
			toRow={(item) => ({
				trackcode: item.stR_SWFollowupCode,
				msisdn: item.inT_MSISDN,
				type: item.stR_BundleName,
				price: complexDigitToman(item.inT_ICCIDWholeSalesPrice),
				commission: complexDigitToman(Math.abs(item.inT_SalesCommission)),
				purchaseDate: convertToJalaliWithTime(item.dtE_OperationDate),
			})}
		/>
	);
};

export default CSListPendingDocument;
